module.exports = "https://www.gc-qa.gnp.com.mx/03f1bef3e938cab4b6d462ed786c4d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/watch_later_24px.png
// module id = 384
// module chunks = 0